// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Presentation page sections
import Counters from "pages/Presentation/sections/Counters";

// Presentation page components

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import img1 from "assets/images/Downloads/img1.jpg";
import img2 from "assets/images/Downloads/img2.jpg";
import img3 from "assets/images/Downloads/img3.jpg";
import img4 from "assets/images/Downloads/img4.jpg";
import img5 from "assets/images/Downloads/img5.jpg";
import { useEffect, useState } from "react";
const images = [img1, img2, img3, img4, img5];

function Presentation() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const intervl = setInterval(() => {
      if (index < images.length) setIndex((index) => (index < images.length - 1 ? index + 1 : 0));
    }, 5000);

    return () => clearInterval(intervl);
  }, []);

  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${images[index]})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={7}
            justifyContent="center"
            mx="auto"
            sx={{
              // color: "#344767",
              backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                rgba(white.main, 0.2),
              backdropFilter: "saturate(100%) blur(10px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
              py: 2,
            }}
          >
            <MKTypography
              variant="h1"
              color="white"
              // mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
                // color: "#3863d9",
                // color: "#344767",
              })}
            >
              Welcome to AF1985 Inc.
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              At AF1985 Inc., we believe that real estate isn't just about bricks and mortar; it's
              about dreams, aspirations, and building communities. With a rich legacy spanning over
              two decades, we have been at the forefront of transforming visions into reality,
              creating iconic structures that stand as testaments to our commitment to excellence.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
